// extracted by mini-css-extract-plugin
module.exports = {"title":"OnboardingHero_title__I76T_","buttons":"OnboardingHero_buttons__A55bU","firstChild":"OnboardingHero_firstChild__vv4ID"};